// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { makeModulationSchemeLabel } from 'redux/helpers'
import { epochToYYYYMMDD } from 'helpers/timeConversion'
import { getBWandTxPowerMax } from '../common'

// instead of creating custom formatters for these cells,
// just put the values of interest at the top level of the object.
const prepData = arr => (
  arr.map(d => {
    // for display purposes, we actually want to treat
    // favoriteRadioCode as the radioCode
    if (d.radioFavorite) {
      d.radioCode = d.radioFavorite.favoriteRadioCode
    }

    const radioFamilyName = (
      d.radioFamilyName
        ? ` - ${d.radioFamilyName}`
        : ''
    )

    // replace epoch date with YYYY/MM/DD
    d.specDate = epochToYYYYMMDD(d.specDate)

    // finds first enabled modulation and assembles radio data for UI accordingly.
    // since we look for the first enabled modulation and not just the first modulation,
    // this will also support radio favorites if so desired.
    d.modulations.find(m => {
      if (m.enabled) {
        d.modulationName = makeModulationSchemeLabel(m.modulationScheme)
        d.rxThreshold = m.rxThreshold
        d.radioModelFamily = `${m.modelNumber}${radioFamilyName}`
        return true
      }
    })

    // bandwidth and txPowerMax aren't necessarily the First Modulation.
    // rather the greatest of these values among all modulations for this radio.
    const { bandwidth, txPowerMax } = getBWandTxPowerMax(d.modulations)
    d.bandwidth = bandwidth
    d.txPowerMax = txPowerMax

    d.frequencyRange = `${d.loFrequency} - ${d.hiFrequency}`
    d.uniqueId = 'radioCode' // so that DataTable can create a unique id
    return d
  })
)

export default prepData
